export default "/static/assets/fit-white.f5a36a40015f63a208c12f2c39f0a714.svg";